import React from 'react';
import { ShareQuotationInput } from './contracts';
import { useShareQuotation } from '../../hooks/useShareQuotation';

type ShareQuotationButtonProps = ShareQuotationInput & {
  label: string;
  className?: string;
  onAfterShare?: () => void;
};

const ShareQuotationButton: React.FC<ShareQuotationButtonProps> = ({
  label,
  className = 'package-editor-btn-primary',
  onAfterShare,
  ...shareInput
}) => {
  const { canShare, isSharing, share } = useShareQuotation(shareInput);
  const handleClick = async () => {
    await share();
    onAfterShare?.();
  };

  return (
    <button type="button" onClick={handleClick} disabled={!canShare} className={className}>
      {isSharing ? (shareInput.download && !shareInput.shareDraft ? 'Downloading…' : 'Sharing…') : label}
    </button>
  );
};

export default ShareQuotationButton;
